// Fechas guardadas en UTC y mostradas en la zona del perfil (America/El_Salvador por defecto).
const LOCALE = 'es-SV';

function dayKey(date: Date, timeZone: string): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
}

export function formatTime(iso: string, timeZone: string): string {
  return new Intl.DateTimeFormat(LOCALE, { timeZone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(iso));
}

/** Para la lista: la hora si es de hoy, «ayer» si fue ayer, la fecha corta si es anterior. */
export function formatListDate(iso: string, timeZone: string, now: Date = new Date()): string {
  const date = new Date(iso);
  const today = dayKey(now, timeZone);
  if (dayKey(date, timeZone) === today) return formatTime(iso, timeZone);
  const yesterday = dayKey(new Date(now.getTime() - 86_400_000), timeZone);
  if (dayKey(date, timeZone) === yesterday) return 'ayer';
  const sameYear = dayKey(date, timeZone).slice(0, 4) === today.slice(0, 4);
  return new Intl.DateTimeFormat(LOCALE, {
    timeZone, day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' }),
  }).format(date).replace('.', '');
}

/** Separador de día en el hilo: «Hoy», «Ayer» o «martes 22 de septiembre». */
export function formatDayHeading(iso: string, timeZone: string, now: Date = new Date()): string {
  const date = new Date(iso);
  const key = dayKey(date, timeZone);
  if (key === dayKey(now, timeZone)) return 'Hoy';
  if (key === dayKey(new Date(now.getTime() - 86_400_000), timeZone)) return 'Ayer';
  const sameYear = key.slice(0, 4) === dayKey(now, timeZone).slice(0, 4);
  return new Intl.DateTimeFormat(LOCALE, {
    timeZone, weekday: 'long', day: 'numeric', month: 'long', ...(sameYear ? {} : { year: 'numeric' }),
  }).format(date);
}

export function sameDay(a: string, b: string, timeZone: string): boolean {
  return dayKey(new Date(a), timeZone) === dayKey(new Date(b), timeZone);
}

/** Tiempo restante de la ventana de respuesta, en palabras. */
export function formatRemaining(untilIso: string, now: Date = new Date()): string {
  const ms = new Date(untilIso).getTime() - now.getTime();
  if (ms <= 0) return 'cerrada';
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  return `${hours} h ${minutes % 60} min`;
}

/** Hace cuánto pasó algo: «hace 5 min», «hace 3 h», «ayer» o la fecha corta. */
export function formatAgo(iso: string, timeZone: string, now: Date = new Date()): string {
  const minutes = Math.floor((now.getTime() - new Date(iso).getTime()) / 60_000);
  if (minutes < 1) return 'hace un momento';
  if (minutes < 60) return `hace ${minutes} min`;
  if (minutes < 24 * 60) return `hace ${Math.floor(minutes / 60)} h`;
  const day = formatListDate(iso, timeZone, now);
  return day === 'ayer' ? 'ayer' : `el ${day}`;
}
